<template>
  <section>
    <h2 class="text-lg font-semibold mb-4">
      <span class="text-indigo-600">2.</span> Choix de la date &amp; heure
    </h2>
    <div v-if="employes.length > 0" class="mb-4">
  <label for="employeSelect" class="block mb-2 text-sm font-medium text-gray-700">
    Filtrer par employé :
  </label>
  <select
    id="employeSelect"
    v-model="selectedEmployeId"
    class="border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
  >
    <option value="">Tous les employés</option>
    <option
      v-for="employe in employes"
      :key="employe._id"
      :value="employe._id"
    >
      {{ employe.prenom }} {{ employe.nom }}
    </option>
  </select>
</div>
    <div
      class="bg-white rounded-xl shadow-md p-5 overflow-x-auto no-scrollbar"
      style="scroll-behavior: smooth;"
    >
      <div class="flex flex-col gap-4">
        <!-- Navigation -->
        <div v-if="!selectedDate" class="flex items-center justify-center gap-4">
          <button
            aria-label="Précédent"
            class="text-indigo-200 hover:text-indigo-400 transition text-xl"
            @click="changeWeek(-1)"
            :disabled="isPreviousDisabled"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <div class="text-sm text-gray-700 font-medium">
            Du {{ visibleDays[0]?.date }} au {{ visibleDays[visibleDays.length - 1]?.date }}
          </div>
          <button
            aria-label="Suivant"
            class="text-indigo-600 hover:text-indigo-800 transition text-xl"
            @click="changeWeek(1)"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>

        <!-- Créneaux -->
        <div class="flex gap-12 flex-nowrap justify-center">
          <template v-if="selectedDate">
            <div class="flex flex-col items-center min-w-[80px]">
              <div class="text-xs text-gray-900 font-normal mb-1 capitalize">
                {{ getDayName(selectedDate) }}
              </div>
              <div class="text-xs text-gray-600 mb-4">{{ selectedDate }}</div>
              <div class="bg-indigo-600 text-white rounded-md w-full py-2 text-sm text-center">
                {{ selectedSlots[selectedDate] }}
              </div>
              <button
                class="text-indigo-600 mt-3 text-sm hover:underline"
                @click="resetSelection"
              >
                Modifier le créneau
              </button>
            </div>
          </template>

          <template v-else>
            <div
              v-for="(day, index) in visibleDays"
              :key="index"
              class="flex flex-col items-center min-w-[80px]"
            >
              <div class="text-xs text-gray-900 font-normal mb-1 capitalize">
                {{ day.name }}
              </div>
              <div class="text-xs text-gray-600 mb-4">{{ day.date }}</div>

              <div v-if="day.timeslots.length > 0" class="w-full">
                <button
                  v-for="(slot, idx) in day.timeslots"
                  :key="idx"
                  type="button"
                  class="bg-gray-100 rounded-md w-full py-2 text-sm text-gray-900 mb-2 cursor-pointer"
                  :class="{
                    'bg-indigo-600 text-white': selectedSlots[day.date] === slot,
                    'hover:bg-indigo-200': selectedSlots[day.date] !== slot,
                  }"
                  @click="selectSlot(day.date, slot)"
                >
                  {{ slot }}
                </button>
              </div>

              <div v-else class="text-xs text-gray-400 italic text-center">
                Aucun créneau disponible
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: {
    selectedServices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      days: [],
      currentWeekIndex: 0,
      selectedSlots: {},
      selectedDate: null,
      firmId: '6825f7fa29a0ebecdccaccf3',
          selectedEmployeId: '', // <--- Pour le filtrage

    };
  },
  computed: {
    selectedServiceIds() {
      return this.selectedServices.map((s) => s._id);
    },
    visibleDays() {
      const startIndex = this.currentWeekIndex * 4;
      return this.days.slice(startIndex, startIndex + 4);
    },
    isPreviousDisabled() {
      const firstVisibleDay = this.visibleDays[0];
      const today = moment().startOf('day');
      const firstDate = moment(firstVisibleDay?.date, 'YYYY-MM-DD');
      return firstDate.isBefore(today);
    },
  },
  methods: {
    changeWeek(direction) {
      const totalWeeks = Math.ceil(this.days.length / 4);
      this.currentWeekIndex = (this.currentWeekIndex + direction + totalWeeks) % totalWeeks;
    },
    selectSlot(date, slot) {
  this.selectedSlots = { [date]: slot };
  this.selectedDate = date;

  this.$emit('creneau-selectionne', {
    date,
    slot,
    employeId: this.selectedEmployeId || null,
  });
},
    resetSelection() {
      this.selectedSlots = {};
      this.selectedDate = null;
    },
    getDayName(date) {
      const options = { weekday: 'long' };
      return new Date(date).toLocaleDateString('fr-FR', options);
    },
    async fetchDisponibilites() {
  this.days = [];
  this.employes = [];

  const baseDate = moment();
  const next28Days = Array.from({ length: 28 }, (_, i) => baseDate.clone().add(i, 'days'));

  for (const date of next28Days) {
    try {
      const res = await axios.post('http://localhost:3000/api/appointment/disponibilites', {
        firmId: this.firmId,
        serviceIds: this.selectedServiceIds,
        date: date.format('YYYY-MM-DD'),
      });

      const disponibilites = res.data.disponibilites || [];

      // Ajout des employés à la liste
      disponibilites.forEach((entry) => {
        const alreadyInList = this.employes.find((e) => e._id === entry.employe._id);
        if (!alreadyInList) {
          this.employes.push(entry.employe);
        }
      });

      // On regroupe tous les créneaux (filtrés ou non)
      const slots = disponibilites
        .filter((d) => {
          return !this.selectedEmployeId || d.employe._id === this.selectedEmployeId;
        })
        .flatMap((d) => d.timeslots);

      this.days.push({
        name: date.format('dddd'),
        date: date.format('YYYY-MM-DD'),
        timeslots: slots,
      });
    } catch (err) {
      console.error(`Erreur pour ${date.format('YYYY-MM-DD')}`, err);
      this.days.push({
        name: date.format('dddd'),
        date: date.format('YYYY-MM-DD'),
        timeslots: [],
      });
    }
  }
},

  },
  watch: {
    selectedServices: {
      handler() {
        this.fetchDisponibilites();
      },
      immediate: true,
      deep: true,
    },
     selectedEmployeId() {
    this.fetchDisponibilites();
  },
  },
};
</script>


  
  
  
  <style scoped>
  /* Custom styles for the component */
  </style>
  